import { sessionPolicySchema } from '@easyflow/shared';
import { DEFAULT_SESSION_POLICY, sessionPolicyToConfig } from '@easyflow/ui-frontend';
import { AUTH_STORAGE_KEYS } from '@/constants/auth';
import type { SessionPolicy } from '@easyflow/shared';
import type { SessionDurations } from '@easyflow/ui-frontend';

/**
 * Persistenza della `sessionPolicy` ricevuta da login/refresh-token, accanto
 * al token. Le durate del motore condiviso `session-idle` non sono costanti
 * locali: all'avvio si leggono da qui, a ogni refresh si aggiornano a caldo.
 */
export function persistSessionPolicy(policy: SessionPolicy): void {
  localStorage.setItem(AUTH_STORAGE_KEYS.SESSION_POLICY, JSON.stringify(policy));
}

export function readStoredSessionPolicy(): SessionPolicy | null {
  const raw = localStorage.getItem(AUTH_STORAGE_KEYS.SESSION_POLICY);
  if (!raw) return null;
  let parsed: unknown;
  try {
    parsed = JSON.parse(raw);
  } catch {
    localStorage.removeItem(AUTH_STORAGE_KEYS.SESSION_POLICY);
    return null;
  }
  const result = sessionPolicySchema.safeParse(parsed);
  if (!result.success) {
    localStorage.removeItem(AUTH_STORAGE_KEYS.SESSION_POLICY);
    return null;
  }
  return result.data;
}

/** Durate effettive: policy persistita, altrimenti il fallback del core. */
export function resolveSessionDurations(): SessionDurations {
  const stored = readStoredSessionPolicy();
  return stored ? sessionPolicyToConfig(stored) : DEFAULT_SESSION_POLICY;
}
